var _defs, _g, _g2, _g3, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginGame2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_36_5",
    "data-name": "Component 36 5",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1920,
    height: 1315.32,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1920 1315.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 1081,
    x2: 0.5,
    y2: 1080,
    gradientTransform: "translate(1920 -641309.51) rotate(-180) scale(1920 -593.81)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b0accd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#517dc6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.51,
    cy: 1081,
    fx: 0.51,
    fy: 1081,
    r: 0.6,
    gradientTransform: "translate(0 1092395.99) scale(1920 -1009.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#58ad66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#5c975d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#589866",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.01,
    y: 874.21,
    width: 1918,
    height: 208.07,
    fill: "none"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.5,
    cy: 1080.49,
    fx: 0.5,
    fy: 1080.49,
    r: 0.77,
    gradientTransform: "translate(583.74 -218101.07) scale(304.09 196.69)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#fff",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.49,
    cy: 1080.45,
    fx: 0.49,
    fy: 1080.45,
    r: 0.63,
    gradientTransform: "translate(-1814201.57 48.62) rotate(90) scale(1082.28 -1679.98)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b2a53",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#0b2a53",
    stopOpacity: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#0b2a53",
    stopOpacity: 0.11
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0b2a53",
    stopOpacity: 0.25
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0b2a53",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#0b2a53",
    stopOpacity: 0.71
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b2a53"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_68154",
    "data-name": "Group 68154"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67133",
    "data-name": "Group 67133"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    d: "m1920,593.81H0V0h1920v593.81Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    y: 573.9,
    width: 1920,
    height: 506.1,
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_44787",
    "data-name": "Group 44787"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886",
    "data-name": "Rectangle 886",
    x: 810.1,
    y: 328.86,
    width: 136.02,
    height: 286.11,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889",
    "data-name": "Rectangle 889",
    x: 894.07,
    y: 463.32,
    width: 192.58,
    height: 151.65,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887",
    "data-name": "Rectangle 887",
    x: 741.4,
    y: 454.49,
    width: 152.68,
    height: 160.48,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893",
    "data-name": "Rectangle 893",
    x: 488.09,
    y: 436.26,
    width: 152.68,
    height: 178.7,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888",
    "data-name": "Rectangle 888",
    x: 623.42,
    y: 375.54,
    width: 137.06,
    height: 239.42,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890",
    "data-name": "Rectangle 890",
    x: 411.75,
    y: 344.31,
    width: 135.33,
    height: 270.65,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891",
    "data-name": "Rectangle 891",
    x: 253.87,
    y: 413.71,
    width: 201.26,
    height: 201.26,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_892",
    "data-name": "Rectangle 892",
    y: 513.19,
    width: 272.96,
    height: 101.77,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990",
    "data-name": "Rectangle 990",
    x: 479.42,
    y: 330.43,
    width: 45.11,
    height: 27.76,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991",
    "data-name": "Rectangle 991",
    x: 885.15,
    y: 312.44,
    width: 37.52,
    height: 60.97,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992",
    "data-name": "Rectangle 992",
    x: 640.77,
    y: 358.19,
    width: 100.63,
    height: 45.11,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993",
    "data-name": "Rectangle 993",
    x: 272.96,
    y: 396.36,
    width: 72.87,
    height: 50.31,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1027",
    "data-name": "Rectangle 1027",
    x: 81.83,
    y: 447.6,
    width: 109.3,
    height: 110.53,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12917",
    "data-name": "Rectangle 12917",
    x: 108.13,
    y: 433.89,
    width: 57.25,
    height: 46.84,
    fill: "#5a82c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_44788",
    "data-name": "Group 44788"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886-2",
    "data-name": "Rectangle 886-2",
    x: 1581.98,
    y: 452.02,
    width: 100.63,
    height: 162.16,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_889-2",
    "data-name": "Rectangle 889-2",
    x: 1630.56,
    y: 523.88,
    width: 289.44,
    height: 90.3,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_887-2",
    "data-name": "Rectangle 887-2",
    x: 1477.89,
    y: 494.47,
    width: 152.68,
    height: 119.71,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_893-2",
    "data-name": "Rectangle 893-2",
    x: 1224.58,
    y: 435.48,
    width: 152.68,
    height: 178.7,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_888-2",
    "data-name": "Rectangle 888-2",
    x: 1359.91,
    y: 374.75,
    width: 137.06,
    height: 239.42,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_890-2",
    "data-name": "Rectangle 890-2",
    x: 1148.24,
    y: 343.53,
    width: 135.33,
    height: 270.65,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_891-2",
    "data-name": "Rectangle 891-2",
    x: 990.36,
    y: 412.92,
    width: 201.26,
    height: 201.26,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_990-2",
    "data-name": "Rectangle 990-2",
    x: 1215.91,
    y: 329.65,
    width: 45.11,
    height: 27.76,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991-2",
    "data-name": "Rectangle 991-2",
    x: 1637.5,
    y: 439.88,
    width: 27.76,
    height: 45.11,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_886-2-2",
    "data-name": "Rectangle 886-2-2",
    x: 1758.35,
    y: 470.38,
    width: 100.63,
    height: 143.8,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_991-2-2",
    "data-name": "Rectangle 991-2-2",
    x: 1780.55,
    y: 458.18,
    width: 41.65,
    height: 45.11,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_992-2",
    "data-name": "Rectangle 992-2",
    x: 1377.26,
    y: 357.41,
    width: 100.63,
    height: 45.11,
    fill: "#5a82c2"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_993-2",
    "data-name": "Rectangle 993-2",
    x: 1009.45,
    y: 395.57,
    width: 72.87,
    height: 50.31,
    fill: "#5a82c2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67131",
    "data-name": "Group 67131"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    x: 103.15,
    y: 463.38,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    x: 273.53,
    y: 435.97,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    x: 273.53,
    y: 467.13,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    x: 349.52,
    y: 468.37,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    x: 442.98,
    y: 361.06,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8",
    "data-name": "Rectangle 8",
    x: 442.98,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    "data-name": "Rectangle 9",
    x: 839.04,
    y: 361.06,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    x: 839.04,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11",
    "data-name": "Rectangle 11",
    x: 659.58,
    y: 398.09,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    "data-name": "Rectangle 12",
    x: 659.58,
    y: 429.24,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67132",
    "data-name": "Group 67132"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13",
    "data-name": "Rectangle 13",
    x: 1791.41,
    y: 560.1,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    "data-name": "Rectangle 14",
    x: 1639.09,
    y: 470.38,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15",
    "data-name": "Rectangle 15",
    x: 1639.09,
    y: 501.53,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16",
    "data-name": "Rectangle 16",
    x: 1253.12,
    y: 367.98,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17",
    "data-name": "Rectangle 17",
    x: 1460.82,
    y: 392.21,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18",
    "data-name": "Rectangle 18",
    x: 1460.82,
    y: 423.37,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    x: 1022.26,
    y: 438.83,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20",
    "data-name": "Rectangle 20",
    x: 1047.07,
    y: 438.83,
    width: 9.97,
    height: 14.12,
    fill: "#70a3d8"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18458",
    "data-name": "Rectangle 18458",
    y: 603.59,
    width: 1920,
    height: 476.41,
    fill: "url(#radial-gradient)"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cloud-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134766",
    "data-name": "Path 134766",
    d: "m289.86,114.46c-6.3-.04-12.42,2.04-17.39,5.91.17-1.35.26-2.7.26-4.06,0-19.6-17.5-35.5-39.08-35.5-9.98-.08-19.64,3.48-27.19,10.01-6.21-24.56-30.41-42.88-59.33-42.88s-55.03,19.8-59.98,45.82c-5.35-3.82-11.77-5.86-18.35-5.82-16.28,0-29.48,11.99-29.48,26.77v.06c-3.45-1.33-7.12-2.02-10.82-2.01-15.19,0-27.51,11.19-27.51,24.99s12.32,24.99,27.51,24.99h261.34c14.68,0,26.58-10.81,26.58-24.14s-11.9-24.14-26.58-24.14Z",
    fill: "#cbd2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134767",
    "data-name": "Path 134767",
    d: "m297.42,161.73c-2.93-7.31-13.66-12.74-26.49-12.74-6.2-.09-12.33,1.32-17.87,4.1.18-.93.27-1.87.27-2.82,0-13.59-17.98-24.61-40.16-24.61-10.86,0-20.7,2.65-27.93,6.94-6.38-17.02-31.24-29.72-60.95-29.72s-56.54,13.73-61.62,31.77c-5.9-2.74-12.34-4.12-18.85-4.04-16.73,0-30.28,8.31-30.28,18.56v.04c-3.33-.85-6.75-1.31-10.19-1.36,4.27,8.77,13.93,14.89,25.16,14.89h261.35c2.56,0,5.1-.34,7.56-1.01Z",
    fill: "#b2bcdf",
    isolation: "isolate",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134768",
    "data-name": "Path 134768",
    d: "m253.51,115.32c-5.48-.03-10.81,1.78-15.14,5.15.15-1.17.23-2.35.23-3.54,0-17.07-15.24-30.91-34.03-30.91-8.69-.07-17.1,3.03-23.67,8.72-5.41-21.38-26.47-37.33-51.66-37.33s-47.91,17.24-52.22,39.9c-4.66-3.33-10.25-5.1-15.97-5.07-14.17,0-25.66,10.44-25.66,23.31v.06c-3-1.16-6.2-1.76-9.42-1.75-13.23,0-23.95,9.74-23.95,21.75s10.72,21.76,23.95,21.76h227.55c12.78,0,23.14-9.41,23.14-21.02s-10.36-21.02-23.14-21.02Z",
    fill: "#cbd2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134769",
    "data-name": "Path 134769",
    d: "m260.09,156.49c-2.55-6.36-11.9-11.09-23.07-11.09-5.4-.08-10.73,1.15-15.56,3.57.15-.81.23-1.63.23-2.45,0-11.83-15.65-21.43-34.96-21.43-9.46,0-18.03,2.3-24.32,6.04-5.56-14.82-27.2-25.88-53.07-25.88s-49.23,11.95-53.66,27.66c-5.14-2.39-10.75-3.59-16.41-3.52-14.56,0-26.37,7.24-26.37,16.16v.04c-2.9-.74-5.88-1.14-8.87-1.19,3.72,7.63,12.13,12.96,21.91,12.96h227.55c2.23,0,4.44-.29,6.59-.88Z",
    fill: "#b2bcdf",
    isolation: "isolate",
    opacity: 0.8
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134772",
    "data-name": "Path 134772",
    d: "m191.65,272.05c-4.13-.02-8.16,1.34-11.42,3.88.11-.88.17-1.78.17-2.67,0-12.87-11.49-23.31-25.66-23.31-6.55-.05-12.9,2.29-17.85,6.57-4.08-16.12-19.96-28.15-38.95-28.15s-36.13,13-39.38,30.09c-3.51-2.51-7.73-3.85-12.04-3.82-10.69,0-19.35,7.87-19.35,17.58v.04c-2.26-.88-4.67-1.32-7.1-1.32-9.98,0-18.06,7.34-18.06,16.4s8.09,16.4,18.06,16.4h171.59c9.64,0,17.45-7.1,17.45-15.85s-7.81-15.84-17.45-15.84Z",
    fill: "#cbd2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134773",
    "data-name": "Path 134773",
    d: "m196.62,303.09c-1.92-4.8-8.97-8.37-17.4-8.37-4.07-.06-8.09.86-11.73,2.69.12-.61.18-1.23.18-1.85,0-8.92-11.8-16.16-26.36-16.16-6.41-.12-12.73,1.45-18.34,4.56-4.19-11.18-20.51-19.51-40.02-19.51s-37.12,9.01-40.46,20.86c-3.88-1.8-8.1-2.7-12.38-2.65-10.98,0-19.88,5.46-19.88,12.19v.03c-2.19-.56-4.43-.86-6.69-.9,3.2,6.13,9.6,9.92,16.52,9.77h171.59c1.68,0,3.35-.22,4.97-.66Z",
    fill: "#b2bcdf",
    isolation: "isolate",
    opacity: 0.81
  })), /*#__PURE__*/React.createElement("g", {
    id: "cloud-1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134774",
    "data-name": "Path 134774",
    d: "m191.65,297.37c-4.13-.02-8.16,1.34-11.42,3.88.11-.88.17-1.78.17-2.67,0-12.87-11.49-23.31-25.66-23.31-6.55-.05-12.9,2.29-17.85,6.57-4.08-16.12-19.96-28.15-38.95-28.15s-36.13,13-39.38,30.09c-3.51-2.51-7.73-3.85-12.05-3.82-10.69,0-19.35,7.87-19.35,17.58v.04c-2.26-.88-4.67-1.32-7.1-1.32-9.97,0-18.06,7.34-18.06,16.4s8.09,16.4,18.06,16.4h171.59c9.64,0,17.45-7.1,17.45-15.85s-7.82-15.84-17.45-15.84Z",
    fill: "#cbd2ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134775",
    "data-name": "Path 134775",
    d: "m196.62,328.41c-1.92-4.8-8.97-8.37-17.4-8.37-4.07-.06-8.09.86-11.73,2.69.12-.61.18-1.23.18-1.85,0-8.92-11.8-16.16-26.36-16.16-6.41-.12-12.73,1.45-18.34,4.56-4.19-11.18-20.51-19.51-40.02-19.51s-37.12,9.01-40.46,20.86c-3.87-1.8-8.1-2.71-12.38-2.65-10.98,0-19.88,5.46-19.88,12.19v.03c-2.19-.56-4.43-.86-6.69-.9,3.2,6.13,9.6,9.92,16.52,9.77h171.59c1.68,0,3.35-.22,4.97-.66Z",
    fill: "#b2bcdf",
    isolation: "isolate",
    opacity: 0.8
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "building"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67134",
    "data-name": "Group 67134"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67266",
    "data-name": "Group 67266"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18688",
    "data-name": "Rectangle 18688",
    x: 0,
    y: 557.03,
    width: 1919,
    height: 52.22,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19131",
    "data-name": "Rectangle 19131",
    x: 233.27,
    y: 497.77,
    width: 198.91,
    height: 67.68,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19132",
    "data-name": "Rectangle 19132",
    x: 466.43,
    y: 466.37,
    width: 216.53,
    height: 99.08,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19133",
    "data-name": "Rectangle 19133",
    x: 1196.58,
    y: 466.37,
    width: 216.53,
    height: 99.08,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19134",
    "data-name": "Rectangle 19134",
    x: 1570.85,
    y: 509.71,
    width: 170.81,
    height: 55.74,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19136",
    "data-name": "Rectangle 19136",
    x: 274.54,
    y: 481.68,
    width: 76.3,
    height: 28.13,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19137",
    "data-name": "Rectangle 19137",
    x: 595.91,
    y: 449.32,
    width: 52.56,
    height: 29.34,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19138",
    "data-name": "Rectangle 19138",
    x: 1790.42,
    y: 503.79,
    width: 101.1,
    height: 73.12,
    fill: "#406cab"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19139",
    "data-name": "Rectangle 19139",
    x: 28.12,
    y: 495.75,
    width: 146.08,
    height: 92.93,
    fill: "#406cab"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134628",
    "data-name": "Path 134628",
    d: "m1.01,608.54v80.07c0,.87.65,1.6,1.52,1.7l218.61,24.96c.43.05.87-.07,1.22-.33l96.17-71.73c.3-.22.65-.34,1.02-.34h1219.52c.95,0,1.71.77,1.71,1.71h0c0,.88.66,1.61,1.53,1.71,0,0,376.7,6.18,376.7,5.16v-42.92c0-.95-.77-1.71-1.71-1.71H2.72c-.95,0-1.71.77-1.71,1.71h0Z",
    fill: "#02004f",
    isolation: "isolate",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67267",
    "data-name": "Group 67267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134629",
    "data-name": "Path 134629",
    d: "m1563.55,652.88c24.55,2.27,54.51-.99,70.77-5.36.79-3.57.22-7.31-1.62-10.47-3.65-8.54-12.21-13.16-19.07-10.31l-.8.2c-.01-2.46-.41-4.91-1.18-7.25-4.66-12.24-16.47-19.46-26.44-16.17-2.98.77-5.7,2.31-7.9,4.46-6.53-12.25-19.06-18.66-29.62-15.15-6.2,1.57-11.37,5.84-14.08,11.63-8.34-15.9-29.02-23.45-47.53-17.36-22.2,5.72-41.29,25.07-43.37,45.5,17.28,24.26,115.21,24.39,120.86,20.28Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_316-2",
    "data-name": "Path 316-2",
    d: "m335.45,664.03c1.3-1.95,2.01-4.22,2.07-6.56,0-8.89-10.68-16.83-27.37-22.05,3.7-4.24,5.79-9.64,5.9-15.27-1.88-18.66-22.71-32.66-46.72-31.4-21.95-.92-41.53,10.64-46.29,27.33-5.66-1.9-11.59-2.85-17.55-2.81-20.72-.86-38.45,11.44-39.7,27.55.03,3.15.8,6.24,2.24,9.04h-1.6c-2.01-.18-4.02-.18-6.03,0-14.56,1.6-24.7,12.08-22.64,23.41h0c1.98,10.89,14.57,18.68,28.66,17.73,5.57,1.44,11.33,2.08,17.08,1.89,27.7,1.94,55.52.9,83-3.09,55.86-4.33,100.45-13.18,99.62-19.65-.46-3.23-12.14-5.28-30.68-6.11Z",
    fill: "#336545"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    "data-name": "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "m1655.77,648.47v4.02l-256.57,8.35-41.48-31.75,298.05,19.38Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "m1396.97,654.97l258.8-6.5-50.33-19.38h-247.72l39.25,25.88Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2",
    "data-name": "Group 3-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2",
    "data-name": "Path 319-2-2",
    d: "m1414.19,643.22l.02-90.37,199.11.4,1.76,84.4-200.9,5.57Z",
    fill: "#c6b49d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848",
    "data-name": "Path 848",
    d: "m1414.33,535.99l198.55.12.45,17.13-199.11.85.11-18.1Z",
    fill: "#637385"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67270",
    "data-name": "Group 67270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67268",
    "data-name": "Group 67268"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2",
    "data-name": "Path 328-2-5-2",
    d: "m1429.39,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-2",
    "data-name": "Path 328-2-5-2-2",
    d: "m1447.04,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-3",
    "data-name": "Path 328-2-5-2-3",
    d: "m1464.69,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-4",
    "data-name": "Path 328-2-5-2-4",
    d: "m1482.35,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-5",
    "data-name": "Path 328-2-5-2-5",
    d: "m1500,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-6",
    "data-name": "Path 328-2-5-2-6",
    d: "m1517.65,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-7",
    "data-name": "Path 328-2-5-2-7",
    d: "m1535.3,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-8",
    "data-name": "Path 328-2-5-2-8",
    d: "m1552.95,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-9",
    "data-name": "Path 328-2-5-2-9",
    d: "m1570.6,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-10",
    "data-name": "Path 328-2-5-2-10",
    d: "m1588.25,584.42h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-11",
    "data-name": "Path 328-2-5-2-11",
    d: "m1429.39,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-12",
    "data-name": "Path 328-2-5-2-12",
    d: "m1447.04,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-13",
    "data-name": "Path 328-2-5-2-13",
    d: "m1464.69,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-14",
    "data-name": "Path 328-2-5-2-14",
    d: "m1482.35,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-15",
    "data-name": "Path 328-2-5-2-15",
    d: "m1500,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-16",
    "data-name": "Path 328-2-5-2-16",
    d: "m1517.65,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-17",
    "data-name": "Path 328-2-5-2-17",
    d: "m1535.3,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-18",
    "data-name": "Path 328-2-5-2-18",
    d: "m1552.95,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-19",
    "data-name": "Path 328-2-5-2-19",
    d: "m1570.6,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-20",
    "data-name": "Path 328-2-5-2-20",
    d: "m1588.25,619.51h12.76v-20.1h-12.76v20.1Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2",
    "data-name": "Path 321-2-5-2",
    d: "m1431.66,586.12h12.3l-1.81-1.7h-12.76l2.27,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134630",
    "data-name": "Path 134630",
    d: "m1442.15,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19140",
    "data-name": "Rectangle 19140",
    x: 1429.39,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-2",
    "data-name": "Path 321-2-5-2-2",
    d: "m1449.31,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134631",
    "data-name": "Path 134631",
    d: "m1459.8,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19141",
    "data-name": "Rectangle 19141",
    x: 1447.04,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-3",
    "data-name": "Path 321-2-5-2-3",
    d: "m1466.96,586.12h12.3l-1.81-1.7h-12.76l2.27,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134632",
    "data-name": "Path 134632",
    d: "m1477.45,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19142",
    "data-name": "Rectangle 19142",
    x: 1464.69,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-4",
    "data-name": "Path 321-2-5-2-4",
    d: "m1484.61,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134633",
    "data-name": "Path 134633",
    d: "m1495.1,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19143",
    "data-name": "Rectangle 19143",
    x: 1482.35,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-5",
    "data-name": "Path 321-2-5-2-5",
    d: "m1502.26,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134634",
    "data-name": "Path 134634",
    d: "m1512.75,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19144",
    "data-name": "Rectangle 19144",
    x: 1500,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-6",
    "data-name": "Path 321-2-5-2-6",
    d: "m1519.91,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134635",
    "data-name": "Path 134635",
    d: "m1530.4,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19145",
    "data-name": "Rectangle 19145",
    x: 1517.65,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-7",
    "data-name": "Path 321-2-5-2-7",
    d: "m1537.56,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134636",
    "data-name": "Path 134636",
    d: "m1548.06,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19146",
    "data-name": "Rectangle 19146",
    x: 1535.3,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-8",
    "data-name": "Path 321-2-5-2-8",
    d: "m1555.22,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134637",
    "data-name": "Path 134637",
    d: "m1565.71,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19147",
    "data-name": "Rectangle 19147",
    x: 1552.95,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-9",
    "data-name": "Path 321-2-5-2-9",
    d: "m1572.87,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134638",
    "data-name": "Path 134638",
    d: "m1583.36,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19148",
    "data-name": "Rectangle 19148",
    x: 1570.6,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-10",
    "data-name": "Path 321-2-5-2-10",
    d: "m1590.52,586.12h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134639",
    "data-name": "Path 134639",
    d: "m1601.01,564.32h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19149",
    "data-name": "Rectangle 19149",
    x: 1588.25,
    y: 564.32,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-11",
    "data-name": "Path 321-2-5-2-11",
    d: "m1431.66,621.21h12.3l-1.81-1.7h-12.76l2.27,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134640",
    "data-name": "Path 134640",
    d: "m1442.15,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19150",
    "data-name": "Rectangle 19150",
    x: 1429.39,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-12",
    "data-name": "Path 321-2-5-2-12",
    d: "m1449.31,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134641",
    "data-name": "Path 134641",
    d: "m1459.8,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19151",
    "data-name": "Rectangle 19151",
    x: 1447.04,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-13",
    "data-name": "Path 321-2-5-2-13",
    d: "m1466.96,621.21h12.3l-1.81-1.7h-12.76l2.27,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134642",
    "data-name": "Path 134642",
    d: "m1477.45,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19152",
    "data-name": "Rectangle 19152",
    x: 1464.69,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-14",
    "data-name": "Path 321-2-5-2-14",
    d: "m1484.61,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134643",
    "data-name": "Path 134643",
    d: "m1495.1,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19153",
    "data-name": "Rectangle 19153",
    x: 1482.35,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-15",
    "data-name": "Path 321-2-5-2-15",
    d: "m1502.26,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134644",
    "data-name": "Path 134644",
    d: "m1512.75,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19154",
    "data-name": "Rectangle 19154",
    x: 1500,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-16",
    "data-name": "Path 321-2-5-2-16",
    d: "m1519.91,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134645",
    "data-name": "Path 134645",
    d: "m1530.4,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19155",
    "data-name": "Rectangle 19155",
    x: 1517.65,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-17",
    "data-name": "Path 321-2-5-2-17",
    d: "m1537.56,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134646",
    "data-name": "Path 134646",
    d: "m1548.06,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19156",
    "data-name": "Rectangle 19156",
    x: 1535.3,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-18",
    "data-name": "Path 321-2-5-2-18",
    d: "m1555.22,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134647",
    "data-name": "Path 134647",
    d: "m1565.71,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19157",
    "data-name": "Rectangle 19157",
    x: 1552.95,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-19",
    "data-name": "Path 321-2-5-2-19",
    d: "m1572.87,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134648",
    "data-name": "Path 134648",
    d: "m1583.36,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19158",
    "data-name": "Rectangle 19158",
    x: 1570.6,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-20",
    "data-name": "Path 321-2-5-2-20",
    d: "m1590.52,621.21h12.3l-1.81-1.7h-12.76l2.26,1.7Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134649",
    "data-name": "Path 134649",
    d: "m1601.01,599.42h1.84v21.77l-1.84-1.7v-20.07Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19159",
    "data-name": "Rectangle 19159",
    x: 1588.25,
    y: 599.42,
    width: 12.76,
    height: 1.46,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67269",
    "data-name": "Group 67269"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134650",
    "data-name": "Path 134650",
    d: "m1429.39,609.67v9.84h12.76v-9.52c-4.25-.13-8.5-.24-12.76-.32Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134651",
    "data-name": "Path 134651",
    d: "m1447.04,610.14v9.37h12.76v-8.99c-4.25-.12-8.51-.25-12.76-.38Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134652",
    "data-name": "Path 134652",
    d: "m1457.79,575.06c-3.58-.03-7.16-.1-10.74-.16v9.52h12.76v-9.35c-.67,0-1.34,0-2.02-.01Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134653",
    "data-name": "Path 134653",
    d: "m1429.39,574.73v9.69h12.76v-9.6c-4.25-.06-8.5-.1-12.76-.09Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134654",
    "data-name": "Path 134654",
    d: "m1464.69,610.63v8.89h12.76v-8.79c-4.25.02-8.5,0-12.76-.09Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134655",
    "data-name": "Path 134655",
    d: "m1574.77,574.73c-1.39.11-2.78.23-4.17.35v9.34h12.76v-10.34c-2.87.19-5.73.42-8.58.65Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134656",
    "data-name": "Path 134656",
    d: "m1559.45,610.02c-2.17-.15-4.33-.29-6.5-.41v9.9h12.76v-8.99c-2.09-.18-4.17-.35-6.26-.5Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134657",
    "data-name": "Path 134657",
    d: "m1555.58,575.94c-.88,0-1.76.01-2.64,0v8.47h12.76v-8.95c-3.37.25-6.74.44-10.12.47Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134658",
    "data-name": "Path 134658",
    d: "m1536.26,575.29c-.32-.02-.64-.04-.96-.06v9.19h12.76v-8.55c-3.94-.11-7.87-.32-11.8-.57Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134659",
    "data-name": "Path 134659",
    d: "m1539.69,609.05c-1.47-.04-2.93-.07-4.4-.09v10.55h12.76v-10.15c-2.78-.13-5.57-.23-8.36-.31Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134660",
    "data-name": "Path 134660",
    d: "m1464.69,575.08v9.34h12.76v-9.61c-4.25.19-8.5.26-12.76.27Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134661",
    "data-name": "Path 134661",
    d: "m1578.99,611.35c-2.8-.05-5.6-.22-8.39-.43v8.59h12.76v-8.14c-1.46,0-2.91,0-4.37-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134662",
    "data-name": "Path 134662",
    d: "m1588.25,611.31v8.2h12.76v-8.46c-4.25.04-8.51.17-12.76.26Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134663",
    "data-name": "Path 134663",
    d: "m1588.25,573.78v10.64h12.76v-10.9c-4.25-.07-8.51.05-12.76.26Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134664",
    "data-name": "Path 134664",
    d: "m1482.35,574.52v9.9h12.76v-10.79c-4.26.19-8.51.59-12.76.9Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134665",
    "data-name": "Path 134665",
    d: "m1482.35,610.67v8.84h12.76v-9.28c-4.25.23-8.5.37-12.76.44Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134666",
    "data-name": "Path 134666",
    d: "m1500,609.92v9.59h12.76v-10.29c-4.25.17-8.51.4-12.76.7Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134667",
    "data-name": "Path 134667",
    d: "m1517.65,574.03v10.38h12.76v-9.52c-4.25-.29-8.5-.61-12.76-.86Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134668",
    "data-name": "Path 134668",
    d: "m1500,573.49v10.92h12.76v-10.65c-4.25-.2-8.5-.32-12.76-.27Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134669",
    "data-name": "Path 134669",
    d: "m1517.65,609.06v10.45h12.76v-10.6c-4.25-.02-8.51.03-12.76.15Z",
    fill: "#4f828e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2-2-2",
    "data-name": "Path 320-2-2-2",
    d: "m1391.63,634.41l22.56,8.81.54-107.22-20.35,6.13-2.76,92.29Z",
    fill: "#3b4654"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4-2",
    "data-name": "Group 4-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1-2",
    "data-name": "Path 1-2",
    d: "m1192.25,685.88l427.77-11.7-107.41-32.55h-387.45l67.09,44.25Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2-2",
    "data-name": "Path 2-2",
    d: "m1620.02,674.18v6.87l-350.68,14.86-77.08-10.02,427.76-11.7Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2-2",
    "data-name": "Group 3-2-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2-2",
    "data-name": "Path 319-2-2-2",
    d: "m1135.24,665.79l.04-154.5,375.56.68,3.01,144.29-378.61,9.53Z",
    fill: "#e0cbaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848-2",
    "data-name": "Path 848-2",
    d: "m1135.47,482.47l374.6.21.77,29.28-375.55,1.45.18-30.94Z",
    fill: "#637385"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67270-2",
    "data-name": "Group 67270-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67268-2",
    "data-name": "Group 67268-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-2-2",
    "data-name": "Path 328-2-5-2-2-2",
    d: "m1196.36,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-2-3",
    "data-name": "Path 328-2-5-2-2-3",
    d: "m1226.54,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-3-2",
    "data-name": "Path 328-2-5-2-3-2",
    d: "m1256.72,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-4-2",
    "data-name": "Path 328-2-5-2-4-2",
    d: "m1286.89,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-5-2",
    "data-name": "Path 328-2-5-2-5-2",
    d: "m1317.07,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-6-2",
    "data-name": "Path 328-2-5-2-6-2",
    d: "m1347.25,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-7-2",
    "data-name": "Path 328-2-5-2-7-2",
    d: "m1377.43,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-8-2",
    "data-name": "Path 328-2-5-2-8-2",
    d: "m1407.6,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-9-2",
    "data-name": "Path 328-2-5-2-9-2",
    d: "m1437.78,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-10-2",
    "data-name": "Path 328-2-5-2-10-2",
    d: "m1467.96,565.26h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-11-2",
    "data-name": "Path 328-2-5-2-11-2",
    d: "m1196.36,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-12-2",
    "data-name": "Path 328-2-5-2-12-2",
    d: "m1226.54,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-13-2",
    "data-name": "Path 328-2-5-2-13-2",
    d: "m1256.72,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-14-2",
    "data-name": "Path 328-2-5-2-14-2",
    d: "m1286.89,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-15-2",
    "data-name": "Path 328-2-5-2-15-2",
    d: "m1317.07,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-16-2",
    "data-name": "Path 328-2-5-2-16-2",
    d: "m1347.25,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-17-2",
    "data-name": "Path 328-2-5-2-17-2",
    d: "m1377.43,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-18-2",
    "data-name": "Path 328-2-5-2-18-2",
    d: "m1407.6,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-19-2",
    "data-name": "Path 328-2-5-2-19-2",
    d: "m1437.78,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-20-2",
    "data-name": "Path 328-2-5-2-20-2",
    d: "m1467.96,625.27h21.81v-34.36h-21.81v34.36Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-2-2",
    "data-name": "Path 321-2-5-2-2-2",
    d: "m1200.24,568.17h21.02l-3.09-2.9h-21.82l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134630-2",
    "data-name": "Path 134630-2",
    d: "m1218.17,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19140-2",
    "data-name": "Rectangle 19140-2",
    x: 1196.36,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-2-3",
    "data-name": "Path 321-2-5-2-2-3",
    d: "m1230.42,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134631-2",
    "data-name": "Path 134631-2",
    d: "m1248.35,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19141-2",
    "data-name": "Rectangle 19141-2",
    x: 1226.54,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-3-2",
    "data-name": "Path 321-2-5-2-3-2",
    d: "m1260.59,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134632-2",
    "data-name": "Path 134632-2",
    d: "m1278.53,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19142-2",
    "data-name": "Rectangle 19142-2",
    x: 1256.72,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-4-2",
    "data-name": "Path 321-2-5-2-4-2",
    d: "m1290.77,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134633-2",
    "data-name": "Path 134633-2",
    d: "m1308.71,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19143-2",
    "data-name": "Rectangle 19143-2",
    x: 1286.9,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-5-2",
    "data-name": "Path 321-2-5-2-5-2",
    d: "m1320.95,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134634-2",
    "data-name": "Path 134634-2",
    d: "m1338.88,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19144-2",
    "data-name": "Rectangle 19144-2",
    x: 1317.07,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-6-2",
    "data-name": "Path 321-2-5-2-6-2",
    d: "m1351.12,568.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134635-2",
    "data-name": "Path 134635-2",
    d: "m1369.06,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19145-2",
    "data-name": "Rectangle 19145-2",
    x: 1347.25,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-7-2",
    "data-name": "Path 321-2-5-2-7-2",
    d: "m1381.3,568.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134636-2",
    "data-name": "Path 134636-2",
    d: "m1399.24,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19146-2",
    "data-name": "Rectangle 19146-2",
    x: 1377.43,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-8-2",
    "data-name": "Path 321-2-5-2-8-2",
    d: "m1411.48,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134637-2",
    "data-name": "Path 134637-2",
    d: "m1429.41,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19147-2",
    "data-name": "Rectangle 19147-2",
    x: 1407.6,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-9-2",
    "data-name": "Path 321-2-5-2-9-2",
    d: "m1441.65,568.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134638-2",
    "data-name": "Path 134638-2",
    d: "m1459.59,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19148-2",
    "data-name": "Rectangle 19148-2",
    x: 1437.78,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-10-2",
    "data-name": "Path 321-2-5-2-10-2",
    d: "m1471.83,568.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134639-2",
    "data-name": "Path 134639-2",
    d: "m1489.77,530.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19149-2",
    "data-name": "Rectangle 19149-2",
    x: 1467.96,
    y: 530.9,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-11-2",
    "data-name": "Path 321-2-5-2-11-2",
    d: "m1200.24,628.17h21.02l-3.09-2.9h-21.82l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134640-2",
    "data-name": "Path 134640-2",
    d: "m1218.17,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19150-2",
    "data-name": "Rectangle 19150-2",
    x: 1196.36,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-12-2",
    "data-name": "Path 321-2-5-2-12-2",
    d: "m1230.42,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134641-2",
    "data-name": "Path 134641-2",
    d: "m1248.35,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19151-2",
    "data-name": "Rectangle 19151-2",
    x: 1226.54,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-13-2",
    "data-name": "Path 321-2-5-2-13-2",
    d: "m1260.59,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134642-2",
    "data-name": "Path 134642-2",
    d: "m1278.53,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19152-2",
    "data-name": "Rectangle 19152-2",
    x: 1256.72,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-14-2",
    "data-name": "Path 321-2-5-2-14-2",
    d: "m1290.77,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134643-2",
    "data-name": "Path 134643-2",
    d: "m1308.71,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19153-2",
    "data-name": "Rectangle 19153-2",
    x: 1286.9,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-15-2",
    "data-name": "Path 321-2-5-2-15-2",
    d: "m1320.95,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134644-2",
    "data-name": "Path 134644-2",
    d: "m1338.88,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19154-2",
    "data-name": "Rectangle 19154-2",
    x: 1317.07,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-16-2",
    "data-name": "Path 321-2-5-2-16-2",
    d: "m1351.12,628.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134645-2",
    "data-name": "Path 134645-2",
    d: "m1369.06,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19155-2",
    "data-name": "Rectangle 19155-2",
    x: 1347.25,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-17-2",
    "data-name": "Path 321-2-5-2-17-2",
    d: "m1381.3,628.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134646-2",
    "data-name": "Path 134646-2",
    d: "m1399.24,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19156-2",
    "data-name": "Rectangle 19156-2",
    x: 1377.43,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-18-2",
    "data-name": "Path 321-2-5-2-18-2",
    d: "m1411.48,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134647-2",
    "data-name": "Path 134647-2",
    d: "m1429.41,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19157-2",
    "data-name": "Rectangle 19157-2",
    x: 1407.6,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-19-2",
    "data-name": "Path 321-2-5-2-19-2",
    d: "m1441.65,628.17h21.02l-3.09-2.9h-21.81l3.87,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134648-2",
    "data-name": "Path 134648-2",
    d: "m1459.59,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19158-2",
    "data-name": "Rectangle 19158-2",
    x: 1437.78,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-20-2",
    "data-name": "Path 321-2-5-2-20-2",
    d: "m1471.83,628.17h21.02l-3.09-2.9h-21.81l3.88,2.9Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134649-2",
    "data-name": "Path 134649-2",
    d: "m1489.77,590.9h3.15v37.21l-3.15-2.91v-34.31Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19159-2",
    "data-name": "Rectangle 19159-2",
    x: 1467.96,
    y: 590.91,
    width: 21.81,
    height: 2.5,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67269-2",
    "data-name": "Group 67269-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134650-2",
    "data-name": "Path 134650-2",
    d: "m1196.36,608.45v16.82h21.81v-16.28c-7.27-.22-14.53-.41-21.81-.54Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134651-2",
    "data-name": "Path 134651-2",
    d: "m1226.54,609.24v16.02h21.81v-15.38c-7.27-.19-14.54-.42-21.81-.65Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134652-2",
    "data-name": "Path 134652-2",
    d: "m1244.9,549.26c-6.12-.06-12.24-.17-18.36-.27v16.27h21.81v-15.98c-1.15,0-2.3,0-3.45-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134653-2",
    "data-name": "Path 134653-2",
    d: "m1196.36,548.7v16.56h21.81v-16.41c-7.27-.11-14.54-.19-21.81-.16Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134654-2",
    "data-name": "Path 134654-2",
    d: "m1256.72,610.08v15.19h21.81v-15.03c-7.27.04-14.54-.02-21.81-.16Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134655-2",
    "data-name": "Path 134655-2",
    d: "m1444.92,548.69c-2.38.2-4.76.4-7.14.6v15.97h21.81v-17.68c-4.9.32-9.79.71-14.67,1.11Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134656-2",
    "data-name": "Path 134656-2",
    d: "m1418.72,609.04c-3.7-.27-7.41-.5-11.12-.7v16.93h21.81v-15.36c-3.57-.31-7.13-.61-10.69-.86Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134657-2",
    "data-name": "Path 134657-2",
    d: "m1412.11,550.76c-1.5.02-3.01.02-4.51.01v14.49h21.81v-15.31c-5.76.42-11.52.75-17.3.81Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134658-2",
    "data-name": "Path 134658-2",
    d: "m1379.07,549.67c-.55-.04-1.09-.07-1.64-.11v15.71h21.81v-14.62c-6.73-.19-13.45-.55-20.17-.97Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134659-2",
    "data-name": "Path 134659-2",
    d: "m1384.94,607.38c-2.5-.07-5.01-.12-7.52-.16v18.04h21.81v-17.36c-4.76-.22-9.53-.39-14.3-.53Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134660-2",
    "data-name": "Path 134660-2",
    d: "m1256.72,549.3v15.97h21.81v-16.43c-7.26.33-14.53.44-21.81.46Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134661-2",
    "data-name": "Path 134661-2",
    d: "m1452.12,611.31c-4.79-.08-9.57-.37-14.34-.73v14.68h21.81v-13.91c-2.49.01-4.98,0-7.47-.04Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134662-2",
    "data-name": "Path 134662-2",
    d: "m1467.96,611.24v14.02h21.81v-14.46c-7.27.06-14.54.29-21.81.44Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134663-2",
    "data-name": "Path 134663-2",
    d: "m1467.96,547.08v18.18h21.81v-18.64c-7.27-.12-14.54.08-21.81.45Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134664-2",
    "data-name": "Path 134664-2",
    d: "m1286.89,548.34v16.93h21.81v-18.46c-7.28.33-14.54,1.01-21.81,1.53Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134665-2",
    "data-name": "Path 134665-2",
    d: "m1286.89,610.14v15.12h21.81v-15.88c-7.27.4-14.54.63-21.81.75Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134666-2",
    "data-name": "Path 134666-2",
    d: "m1317.07,608.87v16.4h21.81v-17.59c-7.28.29-14.55.68-21.81,1.19Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134667-2",
    "data-name": "Path 134667-2",
    d: "m1347.25,547.51v17.75h21.81v-16.28c-7.27-.51-14.54-1.04-21.81-1.48Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134668-2",
    "data-name": "Path 134668-2",
    d: "m1317.07,546.59v18.67h21.81v-18.21c-7.27-.34-14.53-.54-21.81-.47Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134669-2",
    "data-name": "Path 134669-2",
    d: "m1347.25,607.4v17.87h21.81v-18.13c-7.27-.03-14.54.05-21.81.25Z",
    fill: "#4f828e"
  }))))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1194",
    "data-name": "Line 1194",
    x1: 1174.43,
    y1: 491.1,
    x2: 1510.3,
    y2: 491.5,
    fill: "none",
    stroke: "#3b4654",
    strokeMiterlimit: 10,
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335-2",
    "data-name": "Path 335-2",
    d: "m1256.22,673.82l-1067.34,23.79,145.73,58.04,1078.33-30.97-156.73-50.86Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_849",
    "data-name": "Path 849",
    d: "m334.61,755.65l1078.33-30.97v8.81l-1074.33,29.38-149.73-65.19,145.73,57.97Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134671",
    "data-name": "Path 134671",
    d: "m1000.39,704.24c4.7,0,227.77,98.92,227.77,98.92l-257.02,48,169.46,124.25h-262.81s-140.42-157.33-136.89-158.7,270.41-43.63,270.41-43.63l-102.48-67.46,91.55-1.37Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134672",
    "data-name": "Path 134672",
    d: "m1010.36,975.28l-153.58-147.48,256.33-38.62-147.3-90.76,161.89,94.13-258.97,40.7,152,142.03h-10.37Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67319",
    "data-name": "Group 67319"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842",
    "data-name": "Path 842",
    d: "m1024.28,491.24l-144.82,3.5v-130.48h144.82v126.98Z",
    fill: "#627d96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843",
    "data-name": "Path 843",
    d: "m826.51,389.89l52.94-25.58v130.44l-51.47,1.85-1.48-106.7Z",
    fill: "#4a616f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2",
    "data-name": "Path 319-2",
    d: "m744.94,705.85l1.14-267.04,433.12,6.44,3.44,247.17-437.7,13.44Z",
    fill: "#f2dcb7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2",
    "data-name": "Path 320-2",
    d: "m662.39,687.51l82.55,18.32,1.14-280.49-77.97,29.76-5.72,232.41Z",
    fill: "#3b4654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_844",
    "data-name": "Path 844",
    d: "m746.09,425.36l433.12,6.43,1.02,60.97-434.79-3.72.65-63.68Z",
    fill: "#637385"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1195",
    "data-name": "Line 1195",
    x1: 746.08,
    y1: 433.92,
    x2: 1179.2,
    y2: 439.5,
    fill: "none",
    stroke: "#3b4654",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67318",
    "data-name": "Group 67318"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67314",
    "data-name": "Group 67314"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67274",
    "data-name": "Group 67274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67272",
    "data-name": "Group 67272"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-21",
    "data-name": "Path 328-2-5-2-21",
    d: "m765.94,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-21",
    "data-name": "Path 321-2-5-2-21",
    d: "m773.88,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134673",
    "data-name": "Path 134673",
    d: "m810.65,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19160",
    "data-name": "Rectangle 19160",
    x: 765.94,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67273",
    "data-name": "Group 67273"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134674",
    "data-name": "Path 134674",
    d: "m765.94,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67277",
    "data-name": "Group 67277"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67275",
    "data-name": "Group 67275"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-22",
    "data-name": "Path 328-2-5-2-22",
    d: "m765.94,559.13h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-22",
    "data-name": "Path 321-2-5-2-22",
    d: "m773.88,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134675",
    "data-name": "Path 134675",
    d: "m810.65,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19161",
    "data-name": "Rectangle 19161",
    x: 765.94,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67276",
    "data-name": "Group 67276"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134676",
    "data-name": "Path 134676",
    d: "m765.94,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.32Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67280",
    "data-name": "Group 67280"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67278",
    "data-name": "Group 67278"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-23",
    "data-name": "Path 328-2-5-2-23",
    d: "m830.32,559.13h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-23",
    "data-name": "Path 321-2-5-2-23",
    d: "m838.26,565.08h43.1l-6.33-5.95h-44.71l7.95,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134677",
    "data-name": "Path 134677",
    d: "m875.03,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19162",
    "data-name": "Rectangle 19162",
    x: 830.32,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67279",
    "data-name": "Group 67279"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134678",
    "data-name": "Path 134678",
    d: "m830.32,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.32Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67286",
    "data-name": "Group 67286"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67284",
    "data-name": "Group 67284"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-25",
    "data-name": "Path 328-2-5-2-25",
    d: "m898.43,573.93h52.11v-52.9h-52.11v52.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-25",
    "data-name": "Path 321-2-5-2-25",
    d: "m906.37,579.88h50.5l-6.33-5.95h-52.11l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134681",
    "data-name": "Path 134681",
    d: "m950.54,521.03h6.45v58.75l-6.45-5.96v-52.79Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19164",
    "data-name": "Rectangle 19164",
    x: 898.43,
    y: 521.03,
    width: 52.12,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67285",
    "data-name": "Group 67285"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134682",
    "data-name": "Path 134682",
    d: "m898.43,552.61v21.32h52.11v-20.99c-14.9-.23-37.21-.38-52.11-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67289",
    "data-name": "Group 67289"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67287",
    "data-name": "Group 67287"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-26",
    "data-name": "Path 328-2-5-2-26",
    d: "m967.8,573.93h52.11v-52.9h-52.11v52.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-26",
    "data-name": "Path 321-2-5-2-26",
    d: "m975.74,579.88h50.5l-6.33-5.95h-52.11l7.95,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134683",
    "data-name": "Path 134683",
    d: "m1019.91,521.03h6.45v58.75l-6.45-5.96v-52.79Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19165",
    "data-name": "Rectangle 19165",
    x: 967.8,
    y: 521.03,
    width: 52.12,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67288",
    "data-name": "Group 67288"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134684",
    "data-name": "Path 134684",
    d: "m967.8,552.61v21.32h52.11v-20.99c-14.9-.23-37.21-.38-52.11-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67292",
    "data-name": "Group 67292"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67290",
    "data-name": "Group 67290"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-27",
    "data-name": "Path 328-2-5-2-27",
    d: "m830.73,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-27",
    "data-name": "Path 321-2-5-2-27",
    d: "m838.67,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134685",
    "data-name": "Path 134685",
    d: "m875.44,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19166",
    "data-name": "Rectangle 19166",
    x: 830.73,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67291",
    "data-name": "Group 67291"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134686",
    "data-name": "Path 134686",
    d: "m830.73,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67298",
    "data-name": "Group 67298"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67296",
    "data-name": "Group 67296"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-29",
    "data-name": "Path 328-2-5-2-29",
    d: "m1107.19,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-29",
    "data-name": "Path 321-2-5-2-29",
    d: "m1115.13,681.62h43.1l-6.33-5.95h-44.71l7.95,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134689",
    "data-name": "Path 134689",
    d: "m1151.9,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19168",
    "data-name": "Rectangle 19168",
    x: 1107.19,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67297",
    "data-name": "Group 67297"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134690",
    "data-name": "Path 134690",
    d: "m1107.19,641.7v33.96h44.71v-33.63c-14.9-.23-29.8-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67301",
    "data-name": "Group 67301"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67299",
    "data-name": "Group 67299"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-30",
    "data-name": "Path 328-2-5-2-30",
    d: "m1107.19,559.13h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-30",
    "data-name": "Path 321-2-5-2-30",
    d: "m1115.13,565.08h43.1l-6.33-5.95h-44.71l7.95,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134691",
    "data-name": "Path 134691",
    d: "m1151.9,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19169",
    "data-name": "Rectangle 19169",
    x: 1107.19,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67300",
    "data-name": "Group 67300"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134692",
    "data-name": "Path 134692",
    d: "m1107.19,543.09v16.03h44.71v-15.71c-14.9-.23-29.8-.38-44.71-.32Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67298-2",
    "data-name": "Group 67298-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67296-2",
    "data-name": "Group 67296-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-29-2",
    "data-name": "Path 328-2-5-2-29-2",
    d: "m1043.12,675.66h44.71v-94.32h-44.71v94.32Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-29-2",
    "data-name": "Path 321-2-5-2-29-2",
    d: "m1051.06,681.62h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134689-2",
    "data-name": "Path 134689-2",
    d: "m1087.83,581.34h6.45v100.18l-6.45-5.96v-94.22Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19168-2",
    "data-name": "Rectangle 19168-2",
    x: 1043.12,
    y: 581.34,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67297-2",
    "data-name": "Group 67297-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134690-2",
    "data-name": "Path 134690-2",
    d: "m1043.12,641.7v33.96h44.71v-33.63c-14.9-.23-29.81-.38-44.71-.33Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67301-2",
    "data-name": "Group 67301-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67299-2",
    "data-name": "Group 67299-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-30-2",
    "data-name": "Path 328-2-5-2-30-2",
    d: "m1043.12,559.13h44.71v-38.09h-44.71v38.09Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-30-2",
    "data-name": "Path 321-2-5-2-30-2",
    d: "m1051.06,565.08h43.1l-6.33-5.95h-44.71l7.94,5.95Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134691-2",
    "data-name": "Path 134691-2",
    d: "m1087.83,521.03h6.45v43.95l-6.45-5.96v-37.99Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19169-2",
    "data-name": "Rectangle 19169-2",
    x: 1043.12,
    y: 521.03,
    width: 44.71,
    height: 5.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67300-2",
    "data-name": "Group 67300-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134692-2",
    "data-name": "Path 134692-2",
    d: "m1043.12,543.09v16.03h44.71v-15.71c-14.9-.23-29.81-.38-44.71-.32Z",
    fill: "#4f828e"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67315",
    "data-name": "Group 67315"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_845",
    "data-name": "Path 845",
    d: "m1024.79,698.09l-126.45,3.08,1.77-112.15h126.45l-1.77,109.07Z",
    fill: "#5f778e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_846",
    "data-name": "Path 846",
    d: "m1012.67,694.3l-107.2,2.85v-81.55l107.2-.34v79.03Z",
    fill: "#93bec9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134701",
    "data-name": "Path 134701",
    d: "m1020.11,589.02h6.45l-1.77,109.07-4.68-3.51v-105.56Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134702",
    "data-name": "Path 134702",
    d: "m1004.89,694.29l-43.6,1.24v-69.29h43.6v68.05Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134703",
    "data-name": "Path 134703",
    d: "m959.26,694.7l-43.6,1.65v-69.7h43.6v68.05Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134704",
    "data-name": "Path 134704",
    d: "m958.52,659.06c-14.29-.34-28.57-.84-42.86-1.2v38.49l43.6-1.65v-35.63l-.74-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134705",
    "data-name": "Path 134705",
    d: "m994.54,659.1c-5.85.45-11.72.35-17.58.29-5.22-.05-10.44-.14-15.67-.27v36.41l43.6-1.24v-36.37c-3.44.49-6.89.91-10.36,1.17Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134706",
    "data-name": "Path 134706",
    d: "m1020.11,694.57l-121.94,2.59.16,4,126.45-3.08-4.68-3.51Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134707",
    "data-name": "Path 134707",
    d: "m1019.99,596.52l.12-7.5h-120l-.12,7.5h120Z",
    fill: "#506475"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67316",
    "data-name": "Group 67316"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19174",
    "data-name": "Rectangle 19174",
    x: 761.85,
    y: 505.55,
    width: 124.46,
    height: 6.72,
    fill: "#719196"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19175",
    "data-name": "Rectangle 19175",
    x: 761.85,
    y: 500.96,
    width: 124.46,
    height: 6.72,
    fill: "#9fbbbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67317",
    "data-name": "Group 67317"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19176",
    "data-name": "Rectangle 19176",
    x: 1038.24,
    y: 505.55,
    width: 117.78,
    height: 6.72,
    fill: "#719196"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19177",
    "data-name": "Rectangle 19177",
    x: 1038.24,
    y: 500.96,
    width: 117.78,
    height: 6.72,
    fill: "#9fbbbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67317-2",
    "data-name": "Group 67317-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19176-2",
    "data-name": "Rectangle 19176-2",
    x: 900.51,
    y: 505.55,
    width: 117.78,
    height: 6.72,
    fill: "#719196"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19177-2",
    "data-name": "Rectangle 19177-2",
    x: 900.51,
    y: 500.96,
    width: 117.78,
    height: 6.72,
    fill: "#9fbbbc"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67329",
    "data-name": "Group 67329"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134756",
    "data-name": "Path 134756",
    d: "m1812.54,708.64h-11.59s1.9-33.14,1.81-44.19c-.07-7.8,0-32.53,0-32.53l7.83.6s.27,30.91.3,40.96c.03,8.8,1.65,35.16,1.65,35.16Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134757",
    "data-name": "Path 134757",
    d: "m1848.12,597.36c-1.39-8.2-4.64-12.64-7.25-9.9l-.3.2c0-2.33-.15-4.65-.45-6.96-1.77-11.76-6.26-18.69-10.05-15.53-1.39,1.11-2.44,2.6-3,4.29-2.48-11.76-7.24-17.92-11.26-14.55-2.45,1.7-4.42,5.81-5.35,11.17-3.17-15.27-11.03-22.52-18.06-16.67-6.07,3.96-10.46,15.24-12.43,28.73-1.44-2.52-3.12-3.98-4.93-3.98-5.29,0-9.58,12.51-9.58,27.95,0,42.5,18.1,58,43.3,58s33.72-17.85,36.91-31.47c1.3-5.55,4-24.37,2.44-31.27Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134758",
    "data-name": "Path 134758",
    d: "m569.78,859.48l5.94-27.74,8.26,20.81,8.95-26.75,2.97,23.78,8.92-15.85,6.94,15.85,13.87-27.74,2.97,32.7,12.88-18.83,2.97,22.79-74.68.99Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134759",
    "data-name": "Path 134759",
    d: "m1340.97,937.48l8.15-38.05,11.32,28.54,12.28-36.69,4.08,32.61,12.23-21.74,9.51,21.74,19.03-38.05,4.08,44.84,17.67-25.82,4.08,31.25-102.42,1.36Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134760",
    "data-name": "Path 134760",
    d: "m185.81,767.34l4.54-21.17,6.3,15.88,6.83-20.42,2.27,18.15,6.8-12.1,5.29,12.1,10.59-21.17,2.27,24.95,9.83-14.37,2.27,17.39-56.98.76Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134761",
    "data-name": "Path 134761",
    d: "m1504.5,775.75l4.07-18.98,5.65,14.24,6.13-18.3,2.03,16.27,6.1-10.85,4.74,10.85,9.49-18.98,2.03,22.37,8.81-12.88,2.03,15.59-51.09.67Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67332",
    "data-name": "Group 67332"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68163",
    "data-name": "Group 68163"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clippath)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_68162",
    "data-name": "Group 68162"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67331",
    "data-name": "Group 67331"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 1098.95,
    cy: 1138.84,
    rx: 740.73,
    ry: 176.49,
    fill: "#75a0aa"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_67506",
    "data-name": "Group 67506"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Beredskab"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67500",
    "data-name": "Group 67500"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67499",
    "data-name": "Group 67499"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134843",
    "data-name": "Path 134843",
    d: "m1131.39,714.09l-50.23,1.6v-75.69h50.23v74.09Z",
    fill: "#2e4359"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134844",
    "data-name": "Path 134844",
    d: "m1136.97,714.09l-50.23,1.6v-75.69h50.23v74.09Z",
    fill: "#435a7f"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19419",
    "data-name": "Rectangle 19419",
    x: 1094.05,
    y: 647.93,
    width: 34.25,
    height: 3.53,
    fill: "#95a8bf"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19420",
    "data-name": "Rectangle 19420",
    x: 1094.05,
    y: 655.69,
    width: 26.11,
    height: 3.53,
    fill: "#95a8bf"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4-3",
    "data-name": "Group 4-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2-3",
    "data-name": "Path 2-3",
    d: "m491.49,682.2v5.82l-371.99,12.11-60.13-46.03,432.13,28.1Z",
    fill: "#537d86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1-3",
    "data-name": "Path 1-3",
    d: "m116.26,691.63l375.23-9.43-72.97-28.1H59.36l56.9,37.53Z",
    fill: "#75a0aa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3-2-3",
    "data-name": "Group 3-2-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2-3",
    "data-name": "Path 319-2-2-3",
    d: "m141.23,674.59l.03-131.02,288.69.57,2.55,122.37-291.27,8.08Z",
    fill: "#c6b49d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848-3",
    "data-name": "Path 848-3",
    d: "m141.43,519.13l287.88.18.65,24.83-288.68,1.23.15-26.24Z",
    fill: "#637385"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67270-3",
    "data-name": "Group 67270-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67268-3",
    "data-name": "Group 67268-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-3-3",
    "data-name": "Path 328-2-5-2-3-3",
    d: "m163.27,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-2-4",
    "data-name": "Path 328-2-5-2-2-4",
    d: "m188.86,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-3-4",
    "data-name": "Path 328-2-5-2-3-4",
    d: "m214.45,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-4-3",
    "data-name": "Path 328-2-5-2-4-3",
    d: "m240.04,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-5-3",
    "data-name": "Path 328-2-5-2-5-3",
    d: "m265.63,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-6-3",
    "data-name": "Path 328-2-5-2-6-3",
    d: "m291.23,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-7-3",
    "data-name": "Path 328-2-5-2-7-3",
    d: "m316.82,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-8-3",
    "data-name": "Path 328-2-5-2-8-3",
    d: "m342.41,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-9-3",
    "data-name": "Path 328-2-5-2-9-3",
    d: "m368.01,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-10-3",
    "data-name": "Path 328-2-5-2-10-3",
    d: "m393.59,589.34h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-11-3",
    "data-name": "Path 328-2-5-2-11-3",
    d: "m163.27,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-12-3",
    "data-name": "Path 328-2-5-2-12-3",
    d: "m188.86,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-13-3",
    "data-name": "Path 328-2-5-2-13-3",
    d: "m214.45,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-14-3",
    "data-name": "Path 328-2-5-2-14-3",
    d: "m240.04,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-15-3",
    "data-name": "Path 328-2-5-2-15-3",
    d: "m265.63,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-16-3",
    "data-name": "Path 328-2-5-2-16-3",
    d: "m291.23,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-17-3",
    "data-name": "Path 328-2-5-2-17-3",
    d: "m316.82,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-18-3",
    "data-name": "Path 328-2-5-2-18-3",
    d: "m342.41,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-19-3",
    "data-name": "Path 328-2-5-2-19-3",
    d: "m368.01,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-20-3",
    "data-name": "Path 328-2-5-2-20-3",
    d: "m393.59,640.23h18.5v-29.14h-18.5v29.14Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-3-3",
    "data-name": "Path 321-2-5-2-3-3",
    d: "m166.56,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134630-3",
    "data-name": "Path 134630-3",
    d: "m181.77,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19140-3",
    "data-name": "Rectangle 19140-3",
    x: 163.27,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-2-4",
    "data-name": "Path 321-2-5-2-2-4",
    d: "m192.15,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134631-3",
    "data-name": "Path 134631-3",
    d: "m207.36,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19141-3",
    "data-name": "Rectangle 19141-3",
    x: 188.86,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-3-4",
    "data-name": "Path 321-2-5-2-3-4",
    d: "m217.74,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134632-3",
    "data-name": "Path 134632-3",
    d: "m232.95,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19142-3",
    "data-name": "Rectangle 19142-3",
    x: 214.45,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-4-3",
    "data-name": "Path 321-2-5-2-4-3",
    d: "m243.33,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134633-3",
    "data-name": "Path 134633-3",
    d: "m258.54,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19143-3",
    "data-name": "Rectangle 19143-3",
    x: 240.04,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-5-3",
    "data-name": "Path 321-2-5-2-5-3",
    d: "m268.92,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134634-3",
    "data-name": "Path 134634-3",
    d: "m284.13,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19144-3",
    "data-name": "Rectangle 19144-3",
    x: 265.64,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-6-3",
    "data-name": "Path 321-2-5-2-6-3",
    d: "m294.51,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134635-3",
    "data-name": "Path 134635-3",
    d: "m309.72,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19145-3",
    "data-name": "Rectangle 19145-3",
    x: 291.23,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-7-3",
    "data-name": "Path 321-2-5-2-7-3",
    d: "m320.1,591.8h17.83l-2.62-2.46h-18.5l3.28,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134636-3",
    "data-name": "Path 134636-3",
    d: "m335.31,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19146-3",
    "data-name": "Rectangle 19146-3",
    x: 316.82,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-8-3",
    "data-name": "Path 321-2-5-2-8-3",
    d: "m345.7,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134637-3",
    "data-name": "Path 134637-3",
    d: "m360.91,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19147-3",
    "data-name": "Rectangle 19147-3",
    x: 342.41,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-9-3",
    "data-name": "Path 321-2-5-2-9-3",
    d: "m371.29,591.8h17.83l-2.62-2.46h-18.49l3.28,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134638-3",
    "data-name": "Path 134638-3",
    d: "m386.5,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19148-3",
    "data-name": "Rectangle 19148-3",
    x: 368,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-10-3",
    "data-name": "Path 321-2-5-2-10-3",
    d: "m396.88,591.8h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134639-3",
    "data-name": "Path 134639-3",
    d: "m412.09,560.2h2.67v31.56l-2.67-2.46v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19149-3",
    "data-name": "Rectangle 19149-3",
    x: 393.59,
    y: 560.2,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-11-3",
    "data-name": "Path 321-2-5-2-11-3",
    d: "m166.56,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134640-3",
    "data-name": "Path 134640-3",
    d: "m181.77,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19150-3",
    "data-name": "Rectangle 19150-3",
    x: 163.27,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-12-3",
    "data-name": "Path 321-2-5-2-12-3",
    d: "m192.15,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134641-3",
    "data-name": "Path 134641-3",
    d: "m207.36,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19151-3",
    "data-name": "Rectangle 19151-3",
    x: 188.86,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-13-3",
    "data-name": "Path 321-2-5-2-13-3",
    d: "m217.74,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134642-3",
    "data-name": "Path 134642-3",
    d: "m232.95,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19152-3",
    "data-name": "Rectangle 19152-3",
    x: 214.45,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-14-3",
    "data-name": "Path 321-2-5-2-14-3",
    d: "m243.33,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134643-3",
    "data-name": "Path 134643-3",
    d: "m258.54,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19153-3",
    "data-name": "Rectangle 19153-3",
    x: 240.04,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-15-3",
    "data-name": "Path 321-2-5-2-15-3",
    d: "m268.92,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134644-3",
    "data-name": "Path 134644-3",
    d: "m284.13,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19154-3",
    "data-name": "Rectangle 19154-3",
    x: 265.64,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-16-3",
    "data-name": "Path 321-2-5-2-16-3",
    d: "m294.51,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134645-3",
    "data-name": "Path 134645-3",
    d: "m309.72,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19155-3",
    "data-name": "Rectangle 19155-3",
    x: 291.23,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-17-3",
    "data-name": "Path 321-2-5-2-17-3",
    d: "m320.1,642.69h17.83l-2.62-2.46h-18.5l3.28,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134646-3",
    "data-name": "Path 134646-3",
    d: "m335.31,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19156-3",
    "data-name": "Rectangle 19156-3",
    x: 316.82,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-18-3",
    "data-name": "Path 321-2-5-2-18-3",
    d: "m345.7,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134647-3",
    "data-name": "Path 134647-3",
    d: "m360.91,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19157-3",
    "data-name": "Rectangle 19157-3",
    x: 342.41,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-19-3",
    "data-name": "Path 321-2-5-2-19-3",
    d: "m371.29,642.69h17.83l-2.62-2.46h-18.49l3.28,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134648-3",
    "data-name": "Path 134648-3",
    d: "m386.5,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19158-3",
    "data-name": "Rectangle 19158-3",
    x: 368,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-20-3",
    "data-name": "Path 321-2-5-2-20-3",
    d: "m396.88,642.69h17.83l-2.62-2.46h-18.5l3.29,2.46Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134649-3",
    "data-name": "Path 134649-3",
    d: "m412.09,611.09h2.67v31.56l-2.67-2.47v-29.09Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19159-3",
    "data-name": "Rectangle 19159-3",
    x: 393.59,
    y: 611.09,
    width: 18.5,
    height: 2.12,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67269-3",
    "data-name": "Group 67269-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134650-3",
    "data-name": "Path 134650-3",
    d: "m163.27,625.96v14.26h18.5v-13.8c-6.16-.19-12.33-.35-18.5-.46Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134651-3",
    "data-name": "Path 134651-3",
    d: "m188.86,626.64v13.59h18.5v-13.04c-6.17-.16-12.33-.35-18.5-.55Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134652-3",
    "data-name": "Path 134652-3",
    d: "m204.43,575.77c-5.19-.05-10.38-.14-15.57-.23v13.8h18.5v-13.55c-.98,0-1.95,0-2.93-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134653-3",
    "data-name": "Path 134653-3",
    d: "m163.27,575.29v14.05h18.5v-13.91c-6.16-.09-12.33-.16-18.5-.14Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134654-3",
    "data-name": "Path 134654-3",
    d: "m214.45,627.35v12.88h18.5v-12.75c-6.16.03-12.33-.01-18.5-.14Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134655-3",
    "data-name": "Path 134655-3",
    d: "m374.05,575.29c-2.02.17-4.04.34-6.05.51v13.54h18.5v-15c-4.16.28-8.31.61-12.45.95Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134656-3",
    "data-name": "Path 134656-3",
    d: "m351.84,626.47c-3.14-.22-6.28-.42-9.43-.59v14.35h18.5v-13.03c-3.03-.26-6.05-.52-9.07-.73Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134657-3",
    "data-name": "Path 134657-3",
    d: "m346.23,577.05c-1.27.01-2.55.02-3.82.01v12.28h18.5v-12.98c-4.89.36-9.77.63-14.68.69Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134658-3",
    "data-name": "Path 134658-3",
    d: "m318.21,576.12l-1.39-.09v13.32h18.5v-12.4c-5.71-.16-11.41-.46-17.11-.83Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134659-3",
    "data-name": "Path 134659-3",
    d: "m323.19,625.06c-2.12-.06-4.25-.1-6.37-.13v15.3h18.5v-14.72c-4.04-.18-8.08-.33-12.13-.45Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134660-3",
    "data-name": "Path 134660-3",
    d: "m214.45,575.8v13.54h18.5v-13.94c-6.16.28-12.33.38-18.5.4Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134661-3",
    "data-name": "Path 134661-3",
    d: "m380.16,628.39c-4.06-.07-8.12-.32-12.16-.62v12.45h18.5v-11.8c-2.11.01-4.23,0-6.34-.03Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134662-3",
    "data-name": "Path 134662-3",
    d: "m393.59,628.33v11.89h18.5v-12.26c-6.17.05-12.33.24-18.5.37Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134663-3",
    "data-name": "Path 134663-3",
    d: "m393.59,573.92v15.42h18.5v-15.8c-6.17-.1-12.34.07-18.5.39Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134664-3",
    "data-name": "Path 134664-3",
    d: "m240.04,574.99v14.35h18.5v-15.65c-6.18.28-12.33.85-18.5,1.3Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134665-3",
    "data-name": "Path 134665-3",
    d: "m240.04,627.4v12.82h18.5v-13.46c-6.17.34-12.33.53-18.5.64Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134666-3",
    "data-name": "Path 134666-3",
    d: "m265.63,626.32v13.91h18.5v-14.92c-6.17.24-12.34.58-18.5,1.01Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134667-3",
    "data-name": "Path 134667-3",
    d: "m291.23,574.28v15.06h18.5v-13.8c-6.17-.44-12.34-.88-18.5-1.26Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134668-3",
    "data-name": "Path 134668-3",
    d: "m265.63,573.5v15.84h18.5v-15.44c-6.16-.29-12.33-.46-18.5-.4Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134669-3",
    "data-name": "Path 134669-3",
    d: "m291.23,625.07v15.16h18.5v-15.37c-6.17-.03-12.34.05-18.5.22Z",
    fill: "#4f828e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2-2-2-2",
    "data-name": "Path 320-2-2-2-2",
    d: "m108.52,661.82l32.71,12.77.79-155.46-29.51,8.89-3.99,133.8Z",
    fill: "#3b4654"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67326",
    "data-name": "Group 67326"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67326-2",
    "data-name": "Group 67326-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67321",
    "data-name": "Group 67321"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_319-2-2-2-2",
    "data-name": "Path 319-2-2-2-2",
    d: "m342.52,713.45l.86-321.68,378.46-6.23,2.28,315.69-381.6,12.22Z",
    fill: "#e0cbaa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320-2-2-2-3",
    "data-name": "Path 320-2-2-2-3",
    d: "m280.57,699.7l61.95,13.75.85-336.93-58.5,22.32-4.3,300.86Z",
    fill: "#3b4654"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_848-2-2",
    "data-name": "Path 848-2-2",
    d: "m343.78,376.51l378.55,2.11.63,29.59-379.52-.43.34-31.27Z",
    fill: "#637385"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67325",
    "data-name": "Group 67325"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67323",
    "data-name": "Group 67323"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-35",
    "data-name": "Path 328-2-5-2-35",
    d: "m361.03,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-36",
    "data-name": "Path 328-2-5-2-36",
    d: "m396.07,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-37",
    "data-name": "Path 328-2-5-2-37",
    d: "m431.11,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-38",
    "data-name": "Path 328-2-5-2-38",
    d: "m466.16,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-39",
    "data-name": "Path 328-2-5-2-39",
    d: "m501.2,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-40",
    "data-name": "Path 328-2-5-2-40",
    d: "m536.24,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-41",
    "data-name": "Path 328-2-5-2-41",
    d: "m571.29,466.54h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-42",
    "data-name": "Path 328-2-5-2-42",
    d: "m606.33,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-43",
    "data-name": "Path 328-2-5-2-43",
    d: "m641.37,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-44",
    "data-name": "Path 328-2-5-2-44",
    d: "m676.42,466.54h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-45",
    "data-name": "Path 328-2-5-2-45",
    d: "m361.03,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-46",
    "data-name": "Path 328-2-5-2-46",
    d: "m396.07,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-47",
    "data-name": "Path 328-2-5-2-47",
    d: "m431.11,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-48",
    "data-name": "Path 328-2-5-2-48",
    d: "m466.16,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-49",
    "data-name": "Path 328-2-5-2-49",
    d: "m501.2,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-50",
    "data-name": "Path 328-2-5-2-50",
    d: "m536.24,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-51",
    "data-name": "Path 328-2-5-2-51",
    d: "m571.29,536.21h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-52",
    "data-name": "Path 328-2-5-2-52",
    d: "m606.33,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-53",
    "data-name": "Path 328-2-5-2-53",
    d: "m641.37,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-54",
    "data-name": "Path 328-2-5-2-54",
    d: "m676.42,536.21h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-35",
    "data-name": "Path 321-2-5-2-35",
    d: "m365.53,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134709",
    "data-name": "Path 134709",
    d: "m386.36,426.64h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19178",
    "data-name": "Rectangle 19178",
    x: 361.03,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-36",
    "data-name": "Path 321-2-5-2-36",
    d: "m400.57,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134710",
    "data-name": "Path 134710",
    d: "m421.4,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19179",
    "data-name": "Rectangle 19179",
    x: 396.07,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-37",
    "data-name": "Path 321-2-5-2-37",
    d: "m435.61,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134711",
    "data-name": "Path 134711",
    d: "m456.44,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19180",
    "data-name": "Rectangle 19180",
    x: 431.11,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-38",
    "data-name": "Path 321-2-5-2-38",
    d: "m470.66,469.9h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134712",
    "data-name": "Path 134712",
    d: "m491.49,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19181",
    "data-name": "Rectangle 19181",
    x: 466.16,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-39",
    "data-name": "Path 321-2-5-2-39",
    d: "m505.7,469.9h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134713",
    "data-name": "Path 134713",
    d: "m526.53,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19182",
    "data-name": "Rectangle 19182",
    x: 501.2,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-40",
    "data-name": "Path 321-2-5-2-40",
    d: "m540.74,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134714",
    "data-name": "Path 134714",
    d: "m561.57,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19183",
    "data-name": "Rectangle 19183",
    x: 536.24,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-41",
    "data-name": "Path 321-2-5-2-41",
    d: "m575.79,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134715",
    "data-name": "Path 134715",
    d: "m596.61,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19184",
    "data-name": "Rectangle 19184",
    x: 571.29,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-42",
    "data-name": "Path 321-2-5-2-42",
    d: "m610.83,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134716",
    "data-name": "Path 134716",
    d: "m631.66,426.64h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19185",
    "data-name": "Rectangle 19185",
    x: 606.33,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-43",
    "data-name": "Path 321-2-5-2-43",
    d: "m645.87,469.9h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134717",
    "data-name": "Path 134717",
    d: "m666.7,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19186",
    "data-name": "Rectangle 19186",
    x: 641.37,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-44",
    "data-name": "Path 321-2-5-2-44",
    d: "m680.91,469.9h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134718",
    "data-name": "Path 134718",
    d: "m701.74,426.64h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19187",
    "data-name": "Rectangle 19187",
    x: 676.42,
    y: 426.64,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-45",
    "data-name": "Path 321-2-5-2-45",
    d: "m365.53,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134719",
    "data-name": "Path 134719",
    d: "m386.36,496.31h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19188",
    "data-name": "Rectangle 19188",
    x: 361.03,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-46",
    "data-name": "Path 321-2-5-2-46",
    d: "m400.57,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134720",
    "data-name": "Path 134720",
    d: "m421.4,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19189",
    "data-name": "Rectangle 19189",
    x: 396.07,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-47",
    "data-name": "Path 321-2-5-2-47",
    d: "m435.61,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134721",
    "data-name": "Path 134721",
    d: "m456.44,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19190",
    "data-name": "Rectangle 19190",
    x: 431.11,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-48",
    "data-name": "Path 321-2-5-2-48",
    d: "m470.66,539.59h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134722",
    "data-name": "Path 134722",
    d: "m491.49,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19191",
    "data-name": "Rectangle 19191",
    x: 466.16,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-49",
    "data-name": "Path 321-2-5-2-49",
    d: "m505.7,539.59h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134723",
    "data-name": "Path 134723",
    d: "m526.53,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19192",
    "data-name": "Rectangle 19192",
    x: 501.2,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-50",
    "data-name": "Path 321-2-5-2-50",
    d: "m540.74,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134724",
    "data-name": "Path 134724",
    d: "m561.57,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19193",
    "data-name": "Rectangle 19193",
    x: 536.24,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-51",
    "data-name": "Path 321-2-5-2-51",
    d: "m575.79,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134725",
    "data-name": "Path 134725",
    d: "m596.61,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19194",
    "data-name": "Rectangle 19194",
    x: 571.29,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-52",
    "data-name": "Path 321-2-5-2-52",
    d: "m610.83,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134726",
    "data-name": "Path 134726",
    d: "m631.66,496.31h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19195",
    "data-name": "Rectangle 19195",
    x: 606.33,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-53",
    "data-name": "Path 321-2-5-2-53",
    d: "m645.87,539.59h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134727",
    "data-name": "Path 134727",
    d: "m666.7,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19196",
    "data-name": "Rectangle 19196",
    x: 641.37,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-54",
    "data-name": "Path 321-2-5-2-54",
    d: "m680.91,539.59h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134728",
    "data-name": "Path 134728",
    d: "m701.74,496.31h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19197",
    "data-name": "Rectangle 19197",
    x: 676.42,
    y: 496.32,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67324",
    "data-name": "Group 67324"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134729",
    "data-name": "Path 134729",
    d: "m361.03,516.68v19.53h25.33v-18.9c-8.44-.26-16.89-.48-25.33-.63Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134730",
    "data-name": "Path 134730",
    d: "m396.07,517.6v18.61h25.33v-17.86c-8.44-.22-16.89-.48-25.33-.75Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134731",
    "data-name": "Path 134731",
    d: "m417.4,447.95c-7.11-.07-14.22-.19-21.32-.31v18.9h25.33v-18.56c-1.33,0-2.67-.01-4-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134732",
    "data-name": "Path 134732",
    d: "m361.03,447.3v19.24h25.33v-19.05c-8.45-.13-16.89-.22-25.33-.18Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134733",
    "data-name": "Path 134733",
    d: "m431.11,518.57v17.64h25.33v-17.45c-8.44.04-16.88-.02-25.33-.19Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134734",
    "data-name": "Path 134734",
    d: "m649.66,447.29c-2.77.23-5.53.46-8.29.7v18.54h25.33v-20.54c-5.69.38-11.37.82-17.04,1.29Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134735",
    "data-name": "Path 134735",
    d: "m619.24,517.37c-4.3-.31-8.61-.58-12.91-.81v19.66h25.33v-17.84c-4.14-.35-8.27-.71-12.42-1Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134736",
    "data-name": "Path 134736",
    d: "m611.57,449.7c-1.74.02-3.49.02-5.24.01v16.82h25.33v-17.77c-6.69.49-13.38.86-20.09.94Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134737",
    "data-name": "Path 134737",
    d: "m573.2,448.42c-.64-.04-1.27-.08-1.91-.12v18.24h25.32v-16.98c-7.81-.22-15.61-.63-23.41-1.13Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134738",
    "data-name": "Path 134738",
    d: "m580.01,515.44c-2.91-.08-5.82-.14-8.73-.18v20.95h25.32v-20.16c-5.53-.26-11.06-.46-16.59-.62Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134739",
    "data-name": "Path 134739",
    d: "m431.11,447.99v18.54h25.33v-19.07c-8.43.37-16.88.51-25.33.53Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134740",
    "data-name": "Path 134740",
    d: "m658.03,520.01c-5.56-.1-11.11-.43-16.66-.85v17.05h25.33v-16.16c-2.89.02-5.78,0-8.67-.04Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134741",
    "data-name": "Path 134741",
    d: "m676.42,519.93v16.28h25.33v-16.79c-8.44.07-16.89.34-25.33.51Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134742",
    "data-name": "Path 134742",
    d: "m676.42,445.42v21.11h25.33v-21.64c-8.44-.14-16.89.09-25.33.52Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134743",
    "data-name": "Path 134743",
    d: "m466.16,446.88v19.66h25.33v-21.43c-8.45.38-16.89,1.17-25.33,1.78Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134744",
    "data-name": "Path 134744",
    d: "m466.16,518.65v17.56h25.33v-18.44c-8.44.46-16.88.73-25.33.88Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134745",
    "data-name": "Path 134745",
    d: "m501.2,517.17v19.05h25.33v-20.43c-8.45.33-16.89.79-25.33,1.38Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134746",
    "data-name": "Path 134746",
    d: "m536.24,445.92v20.62h25.33v-18.9c-8.44-.59-16.88-1.21-25.33-1.72Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134747",
    "data-name": "Path 134747",
    d: "m501.2,444.85v21.69h25.33v-21.14c-8.44-.4-16.88-.63-25.33-.54Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134748",
    "data-name": "Path 134748",
    d: "m536.24,515.46v20.75h25.33v-21.05c-8.44-.04-16.88.06-25.33.3Z",
    fill: "#4f828e"
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1196",
    "data-name": "Line 1196",
    x1: 343.62,
    y1: 382.98,
    x2: 721.85,
    y2: 385.54,
    fill: "none",
    stroke: "#3b4654",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67322",
    "data-name": "Group 67322"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_842-2",
    "data-name": "Path 842-2",
    d: "m320.97,712.91l-100.76,2.44v-90.79h100.76v88.35Z",
    fill: "#627d96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_843-2",
    "data-name": "Path 843-2",
    d: "m183.37,629.01l36.84-4.42v90.75l-35.81-21.54-1.03-64.79Z",
    fill: "#4a616f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_67325-2",
    "data-name": "Group 67325-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67323-2",
    "data-name": "Group 67323-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-35-2",
    "data-name": "Path 328-2-5-2-35-2",
    d: "m361.03,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-36-2",
    "data-name": "Path 328-2-5-2-36-2",
    d: "m396.07,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-37-2",
    "data-name": "Path 328-2-5-2-37-2",
    d: "m431.11,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-38-2",
    "data-name": "Path 328-2-5-2-38-2",
    d: "m466.16,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-39-2",
    "data-name": "Path 328-2-5-2-39-2",
    d: "m501.2,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-40-2",
    "data-name": "Path 328-2-5-2-40-2",
    d: "m536.24,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-41-2",
    "data-name": "Path 328-2-5-2-41-2",
    d: "m571.29,605.5h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-42-2",
    "data-name": "Path 328-2-5-2-42-2",
    d: "m606.33,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-43-2",
    "data-name": "Path 328-2-5-2-43-2",
    d: "m641.37,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-44-2",
    "data-name": "Path 328-2-5-2-44-2",
    d: "m676.42,605.5h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-45-2",
    "data-name": "Path 328-2-5-2-45-2",
    d: "m361.03,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-46-2",
    "data-name": "Path 328-2-5-2-46-2",
    d: "m396.07,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-47-2",
    "data-name": "Path 328-2-5-2-47-2",
    d: "m431.11,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-48-2",
    "data-name": "Path 328-2-5-2-48-2",
    d: "m466.16,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-49-2",
    "data-name": "Path 328-2-5-2-49-2",
    d: "m501.2,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-50-2",
    "data-name": "Path 328-2-5-2-50-2",
    d: "m536.24,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-51-2",
    "data-name": "Path 328-2-5-2-51-2",
    d: "m571.29,675.17h25.32v-39.9h-25.32v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-52-2",
    "data-name": "Path 328-2-5-2-52-2",
    d: "m606.33,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-53-2",
    "data-name": "Path 328-2-5-2-53-2",
    d: "m641.37,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328-2-5-2-54-2",
    "data-name": "Path 328-2-5-2-54-2",
    d: "m676.42,675.17h25.33v-39.9h-25.33v39.9Z",
    fill: "#6394a1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-35-2",
    "data-name": "Path 321-2-5-2-35-2",
    d: "m365.53,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134709-2",
    "data-name": "Path 134709-2",
    d: "m386.36,565.6h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19178-2",
    "data-name": "Rectangle 19178-2",
    x: 361.03,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-36-2",
    "data-name": "Path 321-2-5-2-36-2",
    d: "m400.57,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134710-2",
    "data-name": "Path 134710-2",
    d: "m421.4,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19179-2",
    "data-name": "Rectangle 19179-2",
    x: 396.07,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-37-2",
    "data-name": "Path 321-2-5-2-37-2",
    d: "m435.61,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134711-2",
    "data-name": "Path 134711-2",
    d: "m456.44,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19180-2",
    "data-name": "Rectangle 19180-2",
    x: 431.11,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-38-2",
    "data-name": "Path 321-2-5-2-38-2",
    d: "m470.66,608.87h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134712-2",
    "data-name": "Path 134712-2",
    d: "m491.49,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19181-2",
    "data-name": "Rectangle 19181-2",
    x: 466.16,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-39-2",
    "data-name": "Path 321-2-5-2-39-2",
    d: "m505.7,608.87h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134713-2",
    "data-name": "Path 134713-2",
    d: "m526.53,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19182-2",
    "data-name": "Rectangle 19182-2",
    x: 501.2,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-40-2",
    "data-name": "Path 321-2-5-2-40-2",
    d: "m540.74,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134714-2",
    "data-name": "Path 134714-2",
    d: "m561.57,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19183-2",
    "data-name": "Rectangle 19183-2",
    x: 536.24,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-41-2",
    "data-name": "Path 321-2-5-2-41-2",
    d: "m575.79,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134715-2",
    "data-name": "Path 134715-2",
    d: "m596.61,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19184-2",
    "data-name": "Rectangle 19184-2",
    x: 571.29,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-42-2",
    "data-name": "Path 321-2-5-2-42-2",
    d: "m610.83,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134716-2",
    "data-name": "Path 134716-2",
    d: "m631.66,565.6h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19185-2",
    "data-name": "Rectangle 19185-2",
    x: 606.33,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-43-2",
    "data-name": "Path 321-2-5-2-43-2",
    d: "m645.87,608.87h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134717-2",
    "data-name": "Path 134717-2",
    d: "m666.7,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19186-2",
    "data-name": "Rectangle 19186-2",
    x: 641.37,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-44-2",
    "data-name": "Path 321-2-5-2-44-2",
    d: "m680.91,608.87h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134718-2",
    "data-name": "Path 134718-2",
    d: "m701.74,565.6h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19187-2",
    "data-name": "Rectangle 19187-2",
    x: 676.42,
    y: 565.6,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-45-2",
    "data-name": "Path 321-2-5-2-45-2",
    d: "m365.53,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134719-2",
    "data-name": "Path 134719-2",
    d: "m386.36,635.27h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19188-2",
    "data-name": "Rectangle 19188-2",
    x: 361.03,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-46-2",
    "data-name": "Path 321-2-5-2-46-2",
    d: "m400.57,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134720-2",
    "data-name": "Path 134720-2",
    d: "m421.4,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19189-2",
    "data-name": "Rectangle 19189-2",
    x: 396.07,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-47-2",
    "data-name": "Path 321-2-5-2-47-2",
    d: "m435.61,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134721-2",
    "data-name": "Path 134721-2",
    d: "m456.44,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19190-2",
    "data-name": "Rectangle 19190-2",
    x: 431.11,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-48-2",
    "data-name": "Path 321-2-5-2-48-2",
    d: "m470.66,678.55h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134722-2",
    "data-name": "Path 134722-2",
    d: "m491.49,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19191-2",
    "data-name": "Rectangle 19191-2",
    x: 466.16,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-49-2",
    "data-name": "Path 321-2-5-2-49-2",
    d: "m505.7,678.55h24.41l-3.59-3.37h-25.32l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134723-2",
    "data-name": "Path 134723-2",
    d: "m526.53,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19192-2",
    "data-name": "Rectangle 19192-2",
    x: 501.2,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-50-2",
    "data-name": "Path 321-2-5-2-50-2",
    d: "m540.74,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134724-2",
    "data-name": "Path 134724-2",
    d: "m561.57,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19193-2",
    "data-name": "Rectangle 19193-2",
    x: 536.24,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-51-2",
    "data-name": "Path 321-2-5-2-51-2",
    d: "m575.79,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134725-2",
    "data-name": "Path 134725-2",
    d: "m596.61,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19194-2",
    "data-name": "Rectangle 19194-2",
    x: 571.29,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-52-2",
    "data-name": "Path 321-2-5-2-52-2",
    d: "m610.83,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134726-2",
    "data-name": "Path 134726-2",
    d: "m631.66,635.27h3.65v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19195-2",
    "data-name": "Rectangle 19195-2",
    x: 606.33,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-53-2",
    "data-name": "Path 321-2-5-2-53-2",
    d: "m645.87,678.55h24.41l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134727-2",
    "data-name": "Path 134727-2",
    d: "m666.7,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19196-2",
    "data-name": "Rectangle 19196-2",
    x: 641.37,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321-2-5-2-54-2",
    "data-name": "Path 321-2-5-2-54-2",
    d: "m680.91,678.55h24.42l-3.59-3.37h-25.33l4.5,3.37Z",
    fill: "#f4ede4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134728-2",
    "data-name": "Path 134728-2",
    d: "m701.74,635.27h3.66v43.21l-3.66-3.38v-39.84Z",
    fill: "#bcbbb3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19197-2",
    "data-name": "Rectangle 19197-2",
    x: 676.42,
    y: 635.27,
    width: 25.33,
    height: 2.9,
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67324-2",
    "data-name": "Group 67324-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134729-2",
    "data-name": "Path 134729-2",
    d: "m361.03,655.64v19.53h25.33v-18.9c-8.44-.25-16.89-.48-25.33-.63Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134730-2",
    "data-name": "Path 134730-2",
    d: "m396.07,656.57v18.61h25.33v-17.86c-8.44-.22-16.89-.49-25.33-.75Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134731-2",
    "data-name": "Path 134731-2",
    d: "m417.4,586.91c-7.11-.07-14.22-.19-21.32-.31v18.9h25.33v-18.56c-1.33-.01-2.67-.01-4-.02Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134732-2",
    "data-name": "Path 134732-2",
    d: "m361.03,586.26v19.24h25.33v-19.05c-8.45-.13-16.89-.21-25.33-.18Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134733-2",
    "data-name": "Path 134733-2",
    d: "m431.11,657.53v17.64h25.33v-17.45c-8.44.04-16.88-.02-25.33-.19Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134734-2",
    "data-name": "Path 134734-2",
    d: "m649.66,586.25c-2.77.23-5.53.46-8.29.7v18.55h25.33v-20.54c-5.69.38-11.37.82-17.04,1.29Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134735-2",
    "data-name": "Path 134735-2",
    d: "m619.24,656.33c-4.3-.31-8.61-.58-12.91-.81v19.66h25.33v-17.84c-4.14-.35-8.27-.7-12.42-1Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134736-2",
    "data-name": "Path 134736-2",
    d: "m611.57,588.66c-1.74.02-3.49.02-5.24.01v16.82h25.33v-17.77c-6.69.49-13.38.87-20.09.94Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134737-2",
    "data-name": "Path 134737-2",
    d: "m573.2,587.38c-.64-.04-1.27-.08-1.91-.12v18.24h25.32v-16.98c-7.81-.22-15.61-.63-23.41-1.13Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134738-2",
    "data-name": "Path 134738-2",
    d: "m580.01,654.4c-2.91-.08-5.82-.14-8.73-.18v20.95h25.32v-20.16c-5.53-.26-11.06-.46-16.59-.62Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134739-2",
    "data-name": "Path 134739-2",
    d: "m431.11,586.95v18.54h25.33v-19.07c-8.43.37-16.88.51-25.33.53Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134740-2",
    "data-name": "Path 134740-2",
    d: "m658.03,658.97c-5.56-.1-11.11-.43-16.66-.85v17.05h25.33v-16.16c-2.89.02-5.78,0-8.67-.04Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134741-2",
    "data-name": "Path 134741-2",
    d: "m676.42,658.89v16.28h25.33v-16.79c-8.44.07-16.89.34-25.33.51Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134742-2",
    "data-name": "Path 134742-2",
    d: "m676.42,584.38v21.11h25.33v-21.64c-8.44-.14-16.89.09-25.33.52Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134743-2",
    "data-name": "Path 134743-2",
    d: "m466.16,585.84v19.66h25.33v-21.43c-8.45.38-16.89,1.17-25.33,1.78Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134744-2",
    "data-name": "Path 134744-2",
    d: "m466.16,657.61v17.56h25.33v-18.44c-8.44.47-16.88.73-25.33.88Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134745-2",
    "data-name": "Path 134745-2",
    d: "m501.2,656.13v19.05h25.33v-20.43c-8.45.33-16.89.79-25.33,1.38Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134746-2",
    "data-name": "Path 134746-2",
    d: "m536.24,584.88v20.62h25.33v-18.9c-8.44-.59-16.88-1.21-25.33-1.72Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134747-2",
    "data-name": "Path 134747-2",
    d: "m501.2,583.81v21.69h25.33v-21.14c-8.44-.4-16.88-.63-25.33-.54Z",
    fill: "#4f828e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134748-2",
    "data-name": "Path 134748-2",
    d: "m536.24,654.42v20.75h25.33v-21.05c-8.44-.03-16.88.07-25.33.3Z",
    fill: "#4f828e"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_134749",
    "data-name": "Path 134749",
    d: "m723.39,701.22l21.76,4.63-60.73-2.57-1.18-256.53,38.99-12.88,1.17,267.35Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67328",
    "data-name": "Group 67328"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134754",
    "data-name": "Path 134754",
    d: "m86.55,722.51h-11.59s1.9-33.14,1.81-44.19c-.07-7.8,0-32.53,0-32.53l7.83.6s.27,30.91.3,40.96c.03,8.8,1.65,35.16,1.65,35.16Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134755",
    "data-name": "Path 134755",
    d: "m122.13,611.23c-1.39-8.2-4.64-12.64-7.25-9.9l-.3.2c0-2.33-.15-4.65-.45-6.96-1.77-11.76-6.26-18.69-10.05-15.53-1.39,1.11-2.44,2.6-3,4.29-2.48-11.76-7.24-17.92-11.25-14.55-2.45,1.7-4.42,5.81-5.35,11.17-3.17-15.27-11.03-22.52-18.06-16.67-6.07,3.96-10.46,15.24-12.44,28.73-1.44-2.52-3.12-3.98-4.93-3.98-5.29,0-9.58,12.51-9.58,27.95,0,42.5,18.1,58,43.3,58s33.72-17.85,36.91-31.47c1.3-5.55,4-24.37,2.44-31.27Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134750",
    "data-name": "Path 134750",
    d: "m1592.78,841.89c-14.04-3.36-45.55-10.83-68.59-16.28,19.33-16.41-11.61-31.97-39.03-41.44-11.61-4.01-52.72-16.43-70.35-19.19-20.48-3.62-34.04-3.82-30.28-.47l.16.32c-5.49-1.31-11.1-2.52-16.65-3.58-29.13-5.33-49.74-6.07-46.16-1.66.67,1.25,3.08,2.8,6.99,4.5-29.85-4.84-48.94-4.96-45.1-.26,1.52,2.66,9.12,6.34,20.67,9.99-38.71-6.33-63.43-4.89-56.82,3.31,3.16,6.46,25.06,15.84,54.47,24.76-7.31-.4-12.37-.04-14.16,1.22-5.28,3.7,20.67,10.26,55.5,22.33,60.47,20.96,103.6,14.62,157.91,8.2,17.33,4.17,47.07,9.11,56.75,11.4,25.84,6.12,106.62,23.46,106.62,23.46l11.55-8.11s-62.98-13.61-83.48-18.52Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67327",
    "data-name": "Group 67327"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134751",
    "data-name": "Path 134751",
    d: "m1686.56,868.5h-21.84s3.58-62.45,3.41-83.29c-.13-14.71,0-61.31,0-61.31l14.76,1.13s.51,58.25.57,77.21c.05,16.59,3.11,66.27,3.11,66.27Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134752",
    "data-name": "Path 134752",
    d: "m1753.62,658.77c-2.61-15.46-8.74-23.82-13.66-18.67l-.57.37c0-4.39-.29-8.77-.84-13.12-3.34-22.16-11.79-35.22-18.94-29.26-2.18,1.47-4.14,4.27-5.66,8.08-4.68-22.17-13.65-33.78-21.21-27.43-4.61,3.2-8.33,10.95-10.09,21.05-5.97-28.78-20.78-42.45-34.04-31.43-11.45,7.46-19.71,28.73-23.44,54.14-2.71-4.75-5.89-7.49-9.28-7.49-9.98,0-18.06,23.58-18.06,52.67,0,80.11,34.12,109.32,81.61,109.32s63.55-33.64,69.57-59.31c2.45-10.45,7.55-45.91,4.6-58.93Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134753",
    "data-name": "Path 134753",
    d: "m1615.98,668.8c-6.93,4.56-12.51,15.01-16.34,28.47,7.61,57.84,38.7,79.74,79.81,79.74,9.39.13,18.72-1.51,27.51-4.84.89-9.56,1.2-19.02.01-24.29-2.27-13.52-7.57-20.83-11.83-16.33l-.5.32c0-3.84-.25-7.67-.73-11.48-2.89-19.38-10.22-30.81-16.41-25.6-1.89,1.29-3.59,3.73-4.9,7.07-4.05-19.39-11.83-29.54-18.38-23.99-4,2.8-7.21,9.58-8.74,18.41-5.17-25.17-18-37.13-29.49-27.48Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_134762",
    "data-name": "Path 134762",
    d: "m408.23,936.97c-16.38-4.44-53.16-14.32-80.05-21.55,23.07-19.57-12.85-39.32-44.78-51.55-13.52-5.18-61.43-21.34-82.05-25.14-23.93-4.91-39.83-5.49-35.5-1.31l.18.4c-6.41-1.74-12.95-3.34-19.45-4.77-34.04-7.22-58.2-8.62-54.1-3.14.75,1.54,3.55,3.5,8.09,5.66-34.9-6.64-57.28-7.24-52.89-1.42,1.71,3.29,10.55,7.96,24,12.7-45.25-8.66-74.27-7.5-66.72,2.67,3.55,7.97,29.01,19.95,63.29,31.56-8.56-.67-14.5-.34-16.64,1.15-6.28,4.4,21.98,19.95,64.56,28.61,85.93,17.49,145.08,17.66,183.01,12.79,20.22,5.51,60.74,15.76,72.03,18.79,30.15,8.1,120.74,28.78,120.74,28.78l13.74-9.62s-73.54-18.14-97.48-24.62Z",
    fill: "#000051",
    isolation: "isolate",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_67330",
    "data-name": "Group 67330"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_134763",
    "data-name": "Path 134763",
    d: "m512.36,971.19h-26.14s4.29-74.76,4.08-99.71c-.15-17.61,0-73.39,0-73.39l17.67,1.36s.61,69.73.68,92.42c.06,19.85,3.72,79.32,3.72,79.32Z",
    fill: "#665049"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134764",
    "data-name": "Path 134764",
    d: "m592.64,720.13c-3.13-18.5-10.46-28.51-16.35-22.35l-.68.44c0-5.25-.34-10.5-1.01-15.71-3.99-26.52-14.12-42.17-22.67-35.03-2.61,1.76-4.95,5.11-6.77,9.67-5.6-26.54-16.34-40.43-25.39-32.83-5.52,3.83-9.97,13.11-12.07,25.2-7.15-34.46-24.88-50.82-40.74-37.62-13.7,8.93-23.59,34.39-28.06,64.81-3.25-5.69-7.05-8.97-11.11-8.97-11.94,0-21.62,28.23-21.62,63.05,0,95.9,40.84,130.86,97.7,130.86s76.08-40.27,83.28-71c2.93-12.51,9.03-54.96,5.5-70.53Z",
    fill: "#407e42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134765",
    "data-name": "Path 134765",
    d: "m427.88,732.13c-8.29,5.46-14.97,17.97-19.56,34.08,9.11,69.24,46.32,95.45,95.54,95.45,11.24.16,22.41-1.81,32.93-5.79,1.06-11.44,1.43-22.77.02-29.07-2.71-16.19-9.07-24.94-14.17-19.55l-.59.39c0-4.59-.3-9.18-.88-13.74-3.46-23.2-12.23-36.88-19.64-30.64-2.26,1.54-4.29,4.47-5.87,8.46-4.85-23.21-14.16-35.37-22-28.72-4.79,3.35-8.64,11.47-10.46,22.04-6.2-30.14-21.56-44.45-35.31-32.9Z",
    fill: "#336545"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20274",
    "data-name": "Rectangle 20274",
    x: 285.49,
    y: 666.06,
    width: 25.76,
    height: 46.9,
    fill: "#4a616f"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "Light",
    cx: 967.73,
    cy: 661.5,
    rx: 235,
    ry: 152,
    fill: "url(#radial-gradient-2)",
    isolation: "isolate",
    opacity: 0.8
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_20272",
    "data-name": "Rectangle 20272",
    x: 0.02,
    width: 1919.98,
    height: 1082.28,
    fill: "url(#radial-gradient-3)",
    isolation: "isolate",
    opacity: 0.2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginGame2);
export default __webpack_public_path__ + "static/media/login-game2.50a6389a7108aa4fd6ca6282a03db768.svg";
export { ForwardRef as ReactComponent };